import React from 'react'
import { Box, Button, Flex, Text, Input, InputProps } from 'toonswap-uikit'
import { useTranslation } from 'contexts/Localization'

interface TokenInputProps extends InputProps {
  max: number | string
  symbol: string
  value: string
  onSelectMax?: () => void
  onChange: (evt: React.FormEvent<HTMLInputElement>) => void
}

const TokenInput: React.FC<TokenInputProps> = ({ max, symbol, onChange, onSelectMax, value }) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Flex justifyContent="flex-end" minHeight="21px" mb="8px">
        <Text color="primary" fontSize="14px">
          {max.toLocaleString()} {symbol} {t('Available')}
        </Text>
      </Flex>
      <Flex alignItems="center">
        <Input style={{ backgroundColor: '#475355' }} onChange={onChange} placeholder="0" value={value} />
        <Flex alignItems="center">
          <Text bold color="primary" mx="8px">
            {symbol}
          </Text>
          <div>
            <Button
              style={{
                backgroundColor: '#fe7b2a',
                color: '#ffffff',
                borderRadius: '12px',
                padding: '12px 16px',
                border: '2px solid #2b3335',
                fontWeight: '600',
              }}
              scale="sm"
              onClick={onSelectMax}
            >
              {t('Max')}
            </Button>
          </div>
        </Flex>
      </Flex>
    </Box>
  )
}

export default TokenInput
